import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BaseUrl = process.env.REACT_APP_BASEURL_SERVER;

export const OrdersAPI = createApi({
    reducerPath: "OrdersAPI",
    baseQuery: fetchBaseQuery({
        baseUrl: BaseUrl,
        prepareHeaders: (headers, { endpoint }) => {
            const token = localStorage.getItem("accessToken");
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            headers.set("Accept", "application/json");

            headers.set("Content-Type", "application/json");
            return headers;
        },
    }),
    endpoints: (builder) => ({
        updateOrderStatus: builder.mutation({
            query: (formData) => ({
                url: `admin/orders/change-order-status`,
                method: "POST",
                body: formData,
            }),
        }),

        getOrderList: builder.query({
            query: () => `admin/orders/list-all-orders`,
        }),
        getOrderbyId: builder.query({
            query: ({ id, orderid }) => `orders/${id}/${orderid}`,
        }),
        editTracingId: builder.mutation({
            query: (formData) => ({
                url: `admin/orders/edit-order-trackid`,
                method: "POST",
                body: formData,
            }),
        }),

        orderSettingsAdd: builder.mutation({
            query: (formData) => ({
                url: `admin/shipping-options`,
                method: "POST",
                body: formData,
            }),
        }),
        displayOrderSettings: builder.query({
            query: () => `admin/shipping-options`,
        }),
        updateOrderSEttings: builder.mutation({
            query: ({formData, id}) => ({
                url: `admin/shipping-options/${id}`,
                method: "PUT",
                body: formData,
            }),
        }),
    }),
});

export const { useGetOrderListQuery, useUpdateOrderStatusMutation, useGetOrderbyIdQuery, useEditTracingIdMutation, useOrderSettingsAddMutation, useDisplayOrderSettingsQuery, useUpdateOrderSEttingsMutation } = OrdersAPI;
